import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureListComponent } from './feature-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [FeatureListComponent],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [FeatureListComponent],
  providers: []
})
export class FeatureListModule {}
